import { FC } from "react";
import { useSelector } from "react-redux";

import { selectHasLiveChatIntegration } from "store/entities/integrations";

import { LcIntegrationTutorial } from "./LcIntegrationTutorial";
import { StandaloneAppTutorial } from "./StandaloneAppTutorial";

export const WelcomeTutorial: FC = () => {
  const hasLiveChatIntegration = useSelector(selectHasLiveChatIntegration);

  if (hasLiveChatIntegration) {
    return <LcIntegrationTutorial />;
  }

  return <StandaloneAppTutorial />;
};
